import React from 'react';
import { Badge } from '../ui/Badge';

export type BookingStatus = 'booked' | 'completed' | 'cancelled' | 'noshow';

const statusConfig: Record<
  BookingStatus,
  { label: string; variant: 'info' | 'success' | 'danger' | 'neutral' }
> = {
  booked: { label: 'Booked', variant: 'info' },
  completed: { label: 'Completed', variant: 'success' },
  cancelled: { label: 'Cancelled', variant: 'neutral' },
  noshow: { label: 'No Show', variant: 'danger' }
};

export const StatusBadge: React.FC<{ status: BookingStatus; className?: string }> = ({
  status,
  className = ''
}) => {
  const config = statusConfig[status] || statusConfig.booked;
  return (
    <Badge variant={config.variant} className={`text-[10px] uppercase font-bold ${className}`}>
      {config.label}
    </Badge>
  );
};
